import { Injectable } from '@angular/core';
import { filter } from 'rxjs';
import { createStore, select, withProps } from '@ngneat/elf';
import { PlatformUser } from '@control-tower/platform-core';

const userStore = createStore(
    { name: 'user' },
    withProps<PlatformUser>({
        id: '',
        firstName: '',
        lastName: '',
        email: '',
    })
);

@Injectable()
export class UserStore {
    get user() {
        return userStore.getValue();
    }

    set user(user: PlatformUser) {
        userStore.update(state => ({
            ...state,
            ...user,
        }));
    }

    getProperty$<TReturn>(
        prop: keyof PlatformUser,
        mapFn: (user: PlatformUser) => TReturn
    ) {
        return userStore.pipe(
            filter(p => !!p[prop]),
            select(mapFn)
        );
    }
}
